import React, { useState } from 'react';
import { Modal, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { WindowInformation } from '../../../services/window-information';
import MyAppText from '../../../components/MyAppText';
import { translate } from '../../../services/translate';
import FormInput from '../../../components/FormInput';
import FormActions from '../../../components/FormActions';
import { cameraService } from '../../../services/central-api/cameras';
import Toast from 'react-native-toast-message';

interface ModalProps {
    setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setCreatePointOfInterest: React.Dispatch<React.SetStateAction<boolean>>;
    isModalVisible: boolean;
    latitude: string;
    longitude: string;
    onClose: () => void;
}

export default function PointOfInterestModal({ isModalVisible, setModalVisible, setCreatePointOfInterest, latitude, longitude, onClose }: ModalProps) {
    const { styles, theme } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    const [name, setName] = useState<string>('');
    const [description, setDescription] = useState<string>('');

    function isFormValid() {
        return name !== '';
    }

    return (
        <Modal transparent={true} visible={isModalVisible} animationType='fade' onRequestClose={() => setModalVisible(false)} >
            <View style={styles.modalContainer}>
                <View style={styles.centeredView}>
                    <View style={[styles.formContainer, windowInfo.isMobile ? { width: '95%' } : {}]}>
                        <MyAppText style={{
                            fontSize: 22,
                            fontWeight: 'bold',
                            color: theme.colors.labelColor,
                        }}>{translate('pointOfInterest')}</MyAppText>
                        <FormInput label={translate('name')} invalid={() => false} value={name} onChangeText={setName} />
                        <FormInput
                            numberOfLines={5}
                            multiline={true}
                            label={translate('description')}
                            invalid={() => false}
                            value={description}
                            onChangeText={setDescription} />
                        <FormActions
                            onSubmit={async () => {
                                setCreatePointOfInterest(false);
                                try {
                                    await cameraService.createPointOfInterest({
                                        name: name,
                                        description: description,
                                        latitude: Number(latitude),
                                        longitude: Number(longitude)
                                    });
                                    setModalVisible(false);
                                    Toast.show({
                                        type: 'sentinelxSuccess',
                                        text1: translate('ActionSuccessfully'),
                                    });
                                    onClose();
                                } catch (error) {
                                    Toast.show({
                                        type: 'sentinelxError',
                                        text1: translate('unexpectedError'),
                                    });
                                } finally {
                                    setName('');
                                    setDescription('');
                                }
                            }}
                            onClose={() => setModalVisible(false)}
                            disabled={!isFormValid()} />
                    </View>
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    modalContainer: {
        flex: 1,
        backgroundColor: '#31313199'
    },
    centeredView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    formContainer: {
        minWidth: 350,
        maxWidth: 400,
        backgroundColor: theme.colors.field.background,
        borderRadius: 2,
        padding: 20,
        minHeight: 200,
        rowGap: 30
    },
}));
